import ChatWorkspace from './ChatWorkspace';
export default ChatWorkspace;
